import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { Award } from 'lucide-react';
export function GartnerBadge() {
  return <section className="py-12 md:py-16" data-id="element-137">
      <div className="container mx-auto px-6 md:px-12" data-id="element-138">
        <SectionReveal data-id="element-139">
          <div className="relative rounded-2xl border border-accent/30 bg-gradient-to-br from-accent/10 via-surface to-surface p-8 md:p-10 overflow-hidden" data-id="element-140">
            <div className="absolute -top-20 -right-20 w-72 h-72 bg-accent/10 rounded-full blur-3xl" data-id="element-141" />
            <div className="relative flex flex-col md:flex-row items-start md:items-center gap-6" data-id="element-142">
              <div className="w-14 h-14 shrink-0 rounded-full bg-base flex items-center justify-center" data-id="element-143">
                <Award className="w-7 h-7 text-accent" data-id="element-144" />
              </div>
              <div className="flex-1" data-id="element-145">
                <p className="text-xs uppercase tracking-widest text-accent font-medium mb-2" data-id="element-146">
                  Industry Recognition
                </p>
                <h3 className="font-serif text-2xl md:text-3xl tracking-tight leading-snug" data-id="element-147">
                  Waydev is featured in the 2026 Gartner&reg; Magic
                  Quadrant&trade; for Developer Productivity Insight Platforms.
                </h3>
                <p className="text-sm text-muted mt-3 max-w-3xl leading-relaxed" data-id="element-148">
                  Recognition from the world&apos;s leading research and
                  advisory firm &mdash; validating the category-defining work
                  behind the platform and the analyst-relations playbook I bring
                  to clients.
                </p>
              </div>
            </div>
          </div>
          <p className="text-[11px] text-muted/70 mt-4 leading-relaxed max-w-4xl" data-id="element-149">
            GARTNER and Magic Quadrant are registered trademarks and service
            marks of Gartner, Inc. and/or its affiliates and are used herein
            with permission. All rights reserved.
          </p>
        </SectionReveal>
      </div>
    </section>;
}